import React from 'react';
import './CurrentCommandComponent.css';
import { useCurrentCommandState } from '../../store/currentCommandStateStore';
import { emitter } from '../../input/AppEvents';
import { useTranslation } from 'react-i18next';

const CurrentCommandComponent = () => {

    const { t } = useTranslation();
    const { commandId, commandInfoVisible, commandNameResourceKey, commandPromptResourceKey, switchPlaneBtnVisible, onSwitchPlane,
          nextBtnVisible, nextBtnEnabled, nextBtnLabelResourceKey, onNext } = useCurrentCommandState();

  return (
    commandInfoVisible && commandId !== null &&
    <div className="command-container">
      <span className="command-status-dot" />
      <div className="command-info">
        <div className="command-name">{t(commandNameResourceKey)}</div>
        <div className="command-tooltip">{t(commandPromptResourceKey)}</div>
      </div>
      <div className="command-actions">
        {switchPlaneBtnVisible && onSwitchPlane &&
          <button className="command-btn command-btn-secondary" onClick={onSwitchPlane} title={t('command.switchInputPlaneTooltip')}>
            {t('command.switchInputPlane')}
          </button>
        }
        {nextBtnVisible && onNext &&
          <button className="command-btn command-btn-primary" onClick={onNext} disabled={!nextBtnEnabled}>
            {t(nextBtnLabelResourceKey)}
          </button>
        }
        <button className="command-btn command-btn-secondary"
                onClick={() => emitter.emit("commandStop", undefined)}>
          {t('common.cancel')}
        </button>
      </div>
    </div>
  );
};

export default CurrentCommandComponent;
